module.exports = __webpack_public_path__ + "img/vue1-doublure_rouge.b14b392d.png";